import React from 'react'

const ArtisteAlternate = ({image, name}) => (
    <div className="artiste-card__alternate">
        <img className="artiste-image__alternate" src={image} alt="" />
        <div className="artiste-details-xs">
            <h3 className="text--large text--white">{name}</h3>
            <p className="text--small text--white mt-1">2000 songs</p>
        </div>                               
    </div>
)

export default ArtisteAlternate;